import type { AppliedFilters } from '~/contracts/common';
import useGetVehicles from '~/hooks/home/services/useGetVehicles';

const freeShippingFilters: Partial<AppliedFilters> = {
  isFreeDelivery: true
};

export default function useGetFreeShippingVehicles() {
  return useGetVehicles(freeShippingFilters, true, 'Free Shipping Vehicles');
}
